import { action, observable } from 'mobx';
import { AuftragStore } from './AuftragStore';
import { ApiStore } from './ApiStore';
import { provideSingleton, inject } from '../utils/decorators';
import { VorgangStore } from './VorgangStore';
import { IAgtPartikelzaehlerMessung } from '../models/ApiTypesAgtPartikelzaehler';
import * as ApiTypeFactory from '../models/ApiTypeFactory';
import { KalibrierungStore } from './KalibrierungStore';
import { IObjektVorlage, IArbeitsmittel, IObjekt } from '../models/ApiTypes';

/** Singleton für globale Eigenschaften zur Kalibrierung eines Partikelzählers */
@provideSingleton(AgtPartikelzaehlerKalibrierungStore)
export class AgtPartikelzaehlerKalibrierungStore extends KalibrierungStore {
  @inject(ApiStore) apiStore: ApiStore;
  @inject(AuftragStore) auftragStore: AuftragStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable datensatz: IAgtPartikelzaehlerMessung = ApiTypeFactory.leererDatensatzAgtPartikelzaehlerMessung();
  @observable objektVorlage: IObjektVorlage | undefined = undefined;
  @observable normale: IArbeitsmittel | undefined = undefined;

  @action clear() {
    this.datensatz = ApiTypeFactory.leererDatensatzAgtPartikelzaehlerMessung();
  }

  @action setJustage(value: boolean) {
    this.datensatz.justage = value;
  }

  @action setObjektVorlage(value: IObjektVorlage | undefined) {
    this.objektVorlage = value;
  }

  @action setObjekt(value: IObjekt | undefined) {
    if (value !== undefined) {
      this.datensatz.objekt = value.objektguid;
    } else {
      this.datensatz.objekt = '';
    }
  }

  /** Setzt das übergebene Arbeitsmittel als zu verwendende Normale */
  @action setNormale(arbeitsmittel: IArbeitsmittel | undefined) {
    this.normale = arbeitsmittel;
    if (arbeitsmittel !== undefined) {
      this.datensatz.pck = arbeitsmittel.arbeitsmittelguid;
    } else {
      this.datensatz.pck = '';
    }
  }

  /** Übernimmt bereits gespeicherte Daten in den Datensatz des Stores */
  @action setMesswerte(value: Partial<IAgtPartikelzaehlerMessung>) {
    const { datensatz } = this;
    // JSON.parse kann an dieser Stelle nicht verwendet werden, weil Daten auch teilweise gespeichert werden können
    // Das würde dann u.U. ein Teil-Interface erzeugen, mit dem die Eingabe nicht mehr funktioniert
    if (value.version) { datensatz.version = value.version; }
    if (value.pruefortparameter) {
      if (value.pruefortparameter.beginn) { datensatz.pruefortparameter.beginn = value.pruefortparameter.beginn; }
      if (value.pruefortparameter.ende) { datensatz.pruefortparameter.ende = value.pruefortparameter.ende; }
    }
    if (value.justage) { datensatz.justage = value.justage; }
    if (value.messreihen) {
      datensatz.messreihen = value.messreihen;
    }
    if (value.messreihenJustage) {
      datensatz.messreihenJustage = value.messreihenJustage;
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/AgtPartikelzaehlerKalibrierungStore.ts